import React from "react";

const PrimaryFolder = ({
  label = "Courses",
  value = 0,
  to = "/files",
  icon,
  className = "",
  handleClick
}) => {
  return (
    <button
      className={`border-none bg-white rounded-xl p-6 flex flex-col gap-[1.2rem] shadow-[0_0_12px_#00000014] min-w-fit w-90 md:w-60 
      transition-all duration-200 hover:shadow-lg hover:-translate-y-1 ${className}`}
      onClick={handleClick}
    >
      <div className="flex justify-between items-center">
        <span className="primary-folder-label">
          {label}
        </span>
        {icon}
      </div>

      <div className="primary-folder-value">
        {value}
      </div>
    </button>
  );
};

export default PrimaryFolder;